<template>
    <div class="wapper">
        <el-page-header @back="goBack" :content="info.id == null ? '新增提成方案' : '修改提成方案'" class="header">
        </el-page-header>
        <div class="content-wapper">
            <el-form :model="info" ref="ruleForm" label-width="170px" style="width:965px;">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="集采类型" prop="jcCategory" :rules="[
                            { required: true, message: '请选择集采类型', trigger: 'blur' }
                        ]">
                            <el-select placeholder="请选择集采类型" v-model="info.jcCategory" style="width:100%;">
                                <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="提成方案名称" prop="commissionName" :rules="[
                            { required: true, message: '请输入提成方案名称', trigger: 'blur' },
                            { max: 60, message: '提成方案名称最大60个字符', trigger: 'blur' },
                        ]">
                            <el-input v-model="info.commissionName" placeholder="请输入提成方案名称">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="所属标签" prop="tagId" :rules="[
                            { required: true, message: '请选择所属标签', trigger: 'blur' }
                        ]">
                            <el-select @change="changeTag" placeholder="请选择所属标签" v-model="info.tagName" style="width:100%;">
                                <el-option v-for="item in tagList" :key="item.id" :label="item.tagName" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="销售提成值" prop="saleCommission" :rules="[
                            { required: true, message: '输入确定的销售提成值', trigger: 'blur' },
                            { pattern: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/, message: '销售提成值必须为小于100的数字且最多保留两位小数', trigger: 'blur' }
                        ]">
                            <el-input v-model="info.saleCommission" placeholder="输入确定的销售提成值" @change="changeSum">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="经理提成值" prop="managerCommission" :rules="[
                            { required: true, message: '请输入确定的提成值', trigger: 'blur' },
                            { pattern: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/, message: '销售提成值必须为小于100的数字且最多保留两位小数', trigger: 'blur' }
                        ]">
                            <el-input v-model="info.managerCommission" placeholder="请输入确定的提成值" @change="changeSum">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总监提成值" prop="directorCommission" :rules="[
                            { required: true, message: '输入确定的提成值', trigger: 'blur' },
                            { pattern: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/, message: '销售提成值必须为小于100的数字且最多保留两位小数', trigger: 'blur' }
                        ]">
                            <el-input v-model="info.directorCommission" placeholder="输入确定的提成值" @change="changeSum">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="总经理提成值" prop="generalManagerCommission" :rules="[
                            { required: true, message: '请输入确定的提成值', trigger: 'blur' },
                            { pattern: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/, message: '销售提成值必须为小于100的数字且最多保留两位小数', trigger: 'blur' }
                        ]">
                            <el-input v-model="info.generalManagerCommission" placeholder="请输入确定的提成值" @change="changeSum">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总提成体系值" prop="sumCommission">
                            <el-input disabled v-model="info.sumCommission" placeholder="系统自动计算，无需填写">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="该方案对应单点售价区间" :rules="[{required: true, message: '输入确定的数值', trigger: 'blur'}]" v-if="info.jcCategory == 1">
                    <el-col :span="4">
                      <el-form-item prop="minUnitPrice" :rules="[
                        { required: true, message: '输入确定的数值', trigger: 'blur' },
                        { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入数字且最多保留两位小数', trigger: 'blur' }
                    ]">
                        <el-input v-model="info.minUnitPrice">
                            <template slot="append">元</template>
                          </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1" class="split">-</el-col>
                    <el-col :span="4">
                      <el-form-item prop="maxUnitPrice" :rules="[
                        { required: true, message: '输入确定的数值', trigger: 'blur' },
                        { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入数字且最多保留两位小数', trigger: 'blur' }
                    ]">
                        <el-input  v-model="info.maxUnitPrice">
                            <template slot="append">元</template>
                          </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                <el-form-item label="备注说明" prop="remarks" style="margin-top:30px">
                    <el-input type="textarea" placeholder="请添加方案备注信息" rows="5" resize="none"
                        v-model="info.remarks"></el-input>
                </el-form-item>
            </el-form>
            <div class="button-wapper">
                <el-button size="small" type="primary" @click="submit">确认提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import _purchasePlan from '../../service/purchase-plan-service'
export default {
    data() {
        return {
            type: this.$route.query.type,
            id:this.$route.query.id,
            categoryList: [],
            tagList: [],
            info: {
                id: this.$route.query.id,
                sumCommission:null,
            } 
        }
    },
    created() {
        this.getTagList();
        this.getcategoryList();
    },
     mounted() {
        // 提成方案详情
         this.getRoyaltyPlanDetalis()
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        // 标签下拉列表
        getTagList() {
            _purchasePlan.getTagList((res) => {
                this.tagList = res;
                
            })
        },
        // 集采类型下拉列表
        getcategoryList() {
            _purchasePlan.getcategoryList({ state: 'JcCategoryEnum' }, (res) => {
                this.categoryList = res;
                
            })
        },
        getRoyaltyPlanDetalis() {
            if (this.id != null && this.type == 'edit') {
                let _loading = this.$loading({ fullscreen: true })
                _purchasePlan.royaltyPlanDetalis(this.id,  response => {
                    _loading.close()
                    this.info = response
                })
            }
        },
        // 提交
        submit() {
            console.log(this.info);
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                }
                let _loading = this.$loading({ fullscreen: true })
                // 提交请求
                if (this.type == 'edit') {
                    _purchasePlan.planSecondEdit(this.info, () => {
                        _loading.close()
                        this.$notify({
                            message: '修改成功',
                            type: 'success'
                        })
                        this.$router.push({
                            path: '/purchase-plan-list'
                        })
                    }, response => {
                        _loading.close()
                        this.$notify({
                            message: response,
                            type: 'warning'
                        })
                    })
                } else {
                    this.info.state = 1;
                    _purchasePlan.planSecondEdit(this.info, () => {
                        _loading.close()
                        this.$notify({
                            message: '创建成功',
                            type: 'success'
                        })
                        this.$router.push({
                            path: '/purchase-plan-list'
                        })
                    }, response => {
                        _loading.close()
                        this.$notify({
                            message: response,
                            type: 'warning'
                        })
                    })
                }
            })
        },
        // 改变标签 
        changeTag(val) {
            const obj = this.tagList.find( item => item.id === val);
            this.info.tagName = obj.tagName
            this.info.tagId = obj.id
           
        },
        changeSum() {
            const sum = (this.info.saleCommission?this.info.saleCommission * 1:0) +
                                      (this.info.managerCommission?this.info.managerCommission * 1:0) + 
                                      (this.info.directorCommission?this.info.directorCommission * 1:0) + 
                                      (this.info.generalManagerCommission?this.info.generalManagerCommission * 1:0);
            this.info.sumCommission = (sum).toFixed(2)
        }
    }
}
</script>

<style scoped>
.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.content-wapper {
    border: 1px solid #d6dbe5;
    border-radius: 3px;
    padding: 15px;
    background: #fff;
}

.cards-template-wapper {
    background: #d6dbe5;
    padding: 15px;
    border-radius: 3px;
}

.cards-template-item {
    margin-right: 15px;
    display: inline-block;
}

.tips {
    font-size: 12px;
}

.selected-wapper {
    font-size: 12px;
    border-top: 1px dashed #909399;
    margin-top: 15px;
    padding-top: 15px;
}

.selected-title {
    display: inline-block;
    width: 80px;
    text-align: left;
    color: #909399;
}

.selected-name {
    display: inline-block;
    margin-right: 20px;
}

.button-wapper {
    margin-left: 150px;
}

.button-wapper .el-button {
    width: 550px;
}

.upload-wapper {
    position: relative;
    display: inline-block;
    margin-right: 15px;
}

.upload-wapper input {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 210px;
    height: 100px;
    opacity: 0;
}

.image-slot span {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    font-size: 12px;
    border: 1px dashed #909399;
    border-radius: 5px;
    color: #909399;
}

.notes {
    font-size: 12px;
    color: #F56C6C;
}

.label-title {
    color: #606266;
    font-size: 12px;
    position: relative;
}

.label-title::after {
    content: "*";
    color: #F56C6C;
    position: absolute;
    left: -10px;
}

.i-content-wapper {
    border: 1px solid #d6dbe5;
    border-bottom: none;
}

.i-content-query {
    padding: 15px;
}

.i-content-query .el-input {
    margin-right: 15px;
}

.info-label {
    font-size: 12px;
}
/deep/ .el-input-group__append{
    padding: 0 6px;
}
.split{
    text-align: center;
}
</style>